import * as Sentry from "@sentry/react";

// A number the user typed wrong is not a fault, and it is by far the most
// common way a dial fails. Reporting it would bury the failures this exists
// to surface.
const USER_ERRORS = ["E_CALL_PARAM_ERROR"];

// Sentry's ignoreErrors drops anything whose message contains "needs
// authentication", which is exactly what the SDK throws when we talk to it
// before iPECS login has completed. That filter earns its keep on the noisy
// background polls, but it also hid every click-to-dial failure, so report
// these under a message of our own and carry the real reason alongside it,
// which ignoreErrors does not inspect.
export function reportFailedCall(error, destinationNumber, mode) {
  try {
    const reason = error?.message ?? String(error);

    if (USER_ERRORS.includes(reason)) return;

    Sentry.captureException(new Error("Outbound call failed"), {
      // extra is not searchable, so the reason goes in a tag too, truncated to
      // stay inside Sentry's tag value limit
      tags: {
        area: "outbound-call",
        call_mode: mode,
        call_failure_reason: reason.slice(0, 190),
      },
      extra: {
        reason,
        destination_number: destinationNumber,
      },
    });
  } catch {
    // reporting must never take the call flow down with it
  }
}
